// The client's typical grant range, required since 2026-09-29 (#103).
//
// A blank range scores zero on grant-size fit for every foundation, which cost
// a client about half its leads and told it nothing. The API enforces the same
// rules (backend/api/onboarding.py, backend/api/preferences.py); this copy
// exists so the form can say what is wrong before the round trip. Keep the
// order-error wording in step with GRANT_RANGE_ORDER_ERROR in
// backend/constants.py.

export function grantRangeError(min, max) {
  if (min === '' || min == null || max === '' || max == null)
    return 'Please enter your typical grant range, smallest and largest.'
  const lo = Number(min)
  const hi = Number(max)
  if (!Number.isFinite(lo) || !Number.isFinite(hi) || lo < 0)
    return 'Please enter your typical grant range as whole dollar amounts.'
  if (hi < 1)
    return 'The largest grant you apply for must be more than $0.'
  if (lo > hi)
    return 'Your typical grant range runs from the smaller amount to the larger one: the minimum cannot be more than the maximum.'
  return null
}
